import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Gem, Box, Package2 } from "lucide-react";
import { CoverBox } from "./DashboardAlbumCard";

const TYPE_ICON = {
  box_or_set:          Package2,
  special_sticker:     Sparkles,
  premium_collectible: Gem,
  other:               Box,
};
const TYPE_LABEL = {
  box_or_set:          "Box or Set",
  special_sticker:     "Special Sticker",
  premium_collectible: "Premium Collectible",
  other:               "Collectible",
};

/**
 * SpecialCollectibleCard — used for anything whose catalog
 * `item_type` is not album / album_variant. Never shows a completion
 * percentage; instead surfaces the item type badge so the collector
 * sees "Special Sticker" or "Box" clearly.
 */
export default function SpecialCollectibleCard({ card }) {
  const Icon = TYPE_ICON[card.item_type] || Sparkles;
  const label = TYPE_LABEL[card.item_type] || "Collectible";
  return (
    <Link
      to={`/dashboard/my-collection/albums/${card.id}`}
      data-testid={`dash-special-${card.id}`}
      title={card.title}
      aria-label={`${card.title} — ${label}`}
      className="group flex flex-col rounded-2xl border-2 border-[var(--ink)] bg-gradient-to-br from-white to-[var(--panini-yellow-soft)] overflow-hidden shadow-[4px_4px_0_var(--ink)] hover:-translate-y-0.5 hover:shadow-[6px_6px_0_var(--ink)] transition-all focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[var(--panini-yellow)]"
    >
      <div className="relative">
        <CoverBox url={card.cover_image_url} title={card.title} />
        <div className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-full bg-black/85 text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1 shadow">
          <Icon size={12} aria-hidden /> {label}
        </div>
      </div>
      <div className="p-4 md:p-5 flex-1 flex flex-col">
        <div className="text-[10px] uppercase tracking-widest text-[var(--smoke)] font-bold truncate">
          {card.subtitle || "Collectible"}
        </div>
        <div className="font-display text-lg md:text-xl leading-tight mt-1 line-clamp-2">{card.title}</div>
        <div className="mt-auto pt-3 text-xs text-[var(--ink)]/70 italic">Ownership tracked</div>
      </div>
    </Link>
  );
}
